import React from "react";
import { useSelector } from "react-redux";
import { ActivityTab } from "components/common/AuditLog";
import { TimesheetActivityTabSkeleton } from "./TimesheetDetailTabSkeletons";

const TimesheetActivityTabPanel = ({ entityType, entityId }) => {
  const loading = useSelector((state) =>
    state.audit?.get("entityActivityLoading")
  );
  const activityData = useSelector((state) =>
    state.audit?.get("entityActivity")
  );

  const isInitialLoading =
    loading && (!activityData?.data || activityData.data.length === 0);

  return (
    <div className="timesheet-tab-content timesheet-activity-tab relative min-h-0">
      <ActivityTab entityType={entityType} entityId={entityId} />
      {isInitialLoading && (
        <div
          className="absolute inset-0 z-10 bg-white px-1 py-1"
          aria-busy="true"
          aria-label="Loading activity"
        >
          <TimesheetActivityTabSkeleton />
        </div>
      )}
    </div>
  );
};

export default TimesheetActivityTabPanel;
